import {Button, Col, Empty, Input, message, Modal, Popover, Row, Space, Spin, TimePicker, Typography, Grid} from "antd";
import {CaretRightOutlined, MoreOutlined, CaretDownOutlined, CloudUploadOutlined} from "@ant-design/icons";
import { useState} from "react";
import {FetchApiInterface} from "../../../interfaces/FetchApi.interface";
import {AxiosResponse} from "axios";
import {ResponseInterface} from "../../../interfaces/Response.interface";
import useFetch from "../../../hooks/useFetch";
import {DpaInterface} from "../../../interfaces/DpaInterface";
import {useTranslation} from "react-i18next";
import useMessageUser from "../../../hooks/useMessageUser";
import {hasAccess} from "../../../utils";
import moment from "moment";

const { useBreakpoint } = Grid;


const { Paragraph } = Typography;

function RegionItem({ data }: { data: DpaInterface }) {

  const { dpaId: id, dpaName, statusRegister, dpaLatitude, dpaLongitude, updatedAt, count,
          dpaPhaseOut, dpaEntryYear, dpaDistance, dpaOptional } = data;
  const { md } = useBreakpoint();

  const { t } = useTranslation();
  const [name, setName] = useState<string>(dpaName);
  const [latitude, setLatitude] = useState<any>(dpaLatitude);
  const [longitude, setLongitude] = useState<any>(dpaLongitude);

  const [phaseOut, setPhaseOut]     = useState<string | undefined>(dpaPhaseOut);
  const [entryYear, setEntryYear]   = useState<number | undefined>(dpaEntryYear);
  const [distance, setDistance]     = useState<string | undefined>(dpaDistance);
  const [optional, setOptional]     = useState<string | undefined>(dpaOptional);

  const [status, setStatus] = useState<boolean>(statusRegister);
  const [open, setOpen] = useState<boolean>(false);
  const [edit, setEdit] = useState<string | null>(null);
  const [editLatitude, setEditLatitude]   = useState<string | null>(null);
  const [editLongitude, setEditLongitude] = useState<string | null>(null);
  const [editPhaseOut, setEditPhaseOut]   = useState<string | undefined>(undefined);
  const [editEntryYear, setEditEntryYear] = useState<string | undefined>(undefined);
  const [editDistance, setEditDistance]   = useState<string | undefined>(undefined);
  const [editOptional, setEditOptional]   = useState<string | undefined>(undefined);

  const [itemDataList, setItemDataList] = useState<Array<DpaInterface>>( []);
  const { fetchApi, loading, downloadFile } = useFetch();
  const { showMessage }  = useMessageUser();

  const setValuesEdit = () => {
    setEdit(name);
    setEditLatitude(latitude);
    setEditLongitude(longitude);
    setEditPhaseOut(phaseOut);
    setEditEntryYear(entryYear !== undefined ? String(entryYear) : undefined);
    setEditDistance(distance);
    setEditOptional(optional);
  }

  const downloadCurrentTemplate = () => {
    message.info(t('processDownloadLocation'));
    downloadFile(`catalogs/dpa/donwload_dpa/${data.dpaId}`, {}, 'get').then(
      (response: any) => {
        if (response.status === 200 ) {
          const binaryData  = [];
          const filename    = `${data.dpaName}_location.xlsx`;

          const file = new File([response.data], filename);

          binaryData.push(file);
          const downloadLink = document.createElement('a');
          downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: response.data.type }));
          downloadLink.setAttribute('download', filename);
          document.body.appendChild(downloadLink);
          downloadLink.click();
        } else {
          message.error(t('processDownloadLocationError'));
        }
      }
    ).catch(e => {
      message.error(t('processDownloadLocationError'));
    })
  }

  const actions = () => {
    return(
      <Space>
        <Button size='small' type='primary' className="btn-border-radius" onClick={setValuesEdit}>{ t('dpaEditButton') }</Button>
        <Button size='small' type='ghost' className="btn-border-radius" danger={status} onClick={deleteItem}>
          { (status) ? t('dpaDesactiveButton') : t('dpaActiveButton') }
        </Button>
        {
          (data.dpaType.dtyName === 'Country') && (
            <Button size='small' type='primary' ghost className="btn-border-radius" onClick={downloadCurrentTemplate}>
              <CloudUploadOutlined />{ (!md)? null : ` ${t('dpaDownloadLocations')}` }
            </Button>
          )
        }
      </Space>
    );
  }

  const getRegisters = () => {
    const dataSend: FetchApiInterface = {
      url: '/catalogs/dpa/get_dpa',
      method: 'POST',
      data: {
        dpaFatherId: id,
      }
    }
    fetchApi(dataSend ).then(
      ({ data }: AxiosResponse<ResponseInterface>) => {
        if (data.status === 'success') {
          showMessage(data?.message);
          setItemDataList(data.data);
        } else {
          showMessage(data?.message, 'info');
        }
      }
    ).catch((reason: any) => {
      showMessage(reason?.message, 'error');
    });
  }

  const deleteItem = () => {
    const dataSend: FetchApiInterface = {
      url: '/catalogs/dpa/update_dpa',
      data: {
        dpaId: data.dpaId,
        statusRegister: !status
      }
    }
    fetchApi(dataSend).then(
      ({ data }: AxiosResponse<ResponseInterface>) => {
        if (data.status === 'success') {
          showMessage(data?.message);
          setStatus(!status);
        } else {
          showMessage(data?.message, 'info');
        }
      }
    ).catch((reason: any) => {
      showMessage(reason?.message, 'error');
    });
  }

  const getList = () => {
    if (edit !== null) {
      return;
    }
    if (!open) {
      getRegisters();
    }
    setOpen(!open);
  }

  const saveUpdate = () => {
    if (!Boolean(edit)) {
      message.error('Campo requerido.')
      return;
    }
    var pattern = /^[\d.-]+$/;
    if (editLatitude?.length && !pattern.test(editLatitude)) {
      message.error('Valor latitud no es correcta.');
      return;
    }
    if (editLongitude?.length && !pattern.test(editLongitude)) {
      message.error('Valor longitude no es correcta.');
      return;
    }

    const dataSend: FetchApiInterface = {
      url: 'catalogs/dpa/update_dpa',
      method: 'POST',
      data: {
        ...data,
        dpaName: edit,
        dpaLatitude: editLatitude,
        dpaLongitude: editLongitude,
        dpaPhaseOut: editPhaseOut,
        dpaEntryYear: editEntryYear !== undefined ? Number(editEntryYear) : undefined,
        dpaDistance: editDistance,
        dpaOptional: editOptional,
      }
    }
    fetchApi(dataSend).then(
      ({ data }: AxiosResponse<ResponseInterface>) => {
        if (data.status === 'success') {
          message.success(data.message);
          if (edit) {
            setName(edit);
            setLatitude(editLatitude);
            setLongitude(editLongitude);
            setPhaseOut(editPhaseOut);
            setEntryYear(editEntryYear !== undefined ? Number(editEntryYear) : undefined);
            setDistance(editDistance);
            setOptional(editOptional);
          }
          setEdit(null);
        } else {
          message.error(data.message);
        }
      }
    ).catch((reason: any) => {
      const msg = (reason?.message && reason.message.includes('code_')) ? reason?.message : 'Server error.';
      message.error(msg);
    });
  }

  return(
    <>
      <Row className='region-item'>
        <Col flex='auto' onClick={getList}>
          <Spin spinning={loading}>
            <Space>
              {(open) ? <CaretDownOutlined /> : <CaretRightOutlined />}
              <Paragraph className='m-0 no-selected-user' style={{ color: (status ? '' : 'red') }}>
                <b>{ count }</b> { name } <small className='text-gray'>
                  {updatedAt ? moment(updatedAt).format('DD-MM-YYYY') : ''}
                </small>
                {(latitude && longitude) && (
                  <>&nbsp;| <b> LAT: </b> { latitude }<b> LNG: </b> { longitude }</>
                )}
                {phaseOut && <>&nbsp;| <b> Phase Out: </b> { phaseOut }</>}
                {entryYear && <>&nbsp;| <b> Entry Year: </b> { entryYear }</>}
                {distance && <>&nbsp;| <b> Distance: </b> { distance }</>}
                {optional && <>&nbsp;| <b> Optional: </b> { optional }</>}
              </Paragraph>
            </Space>
          </Spin>
        </Col>
        {(hasAccess(['ROLE_USER', 'ROLE_GUEST'])) && (
          <Col>
            <Popover title="Subnivel" placement="left" content={actions}>
              <Button shape='circle' icon={<MoreOutlined />} />
            </Popover>
          </Col>
        )}
      </Row>

      <Modal
        title={name}
        open={edit !== null}
        onCancel={() => setEdit(null)}
        onOk={saveUpdate}
        okText={t('dpaFormSave')}
        cancelText='Cancelar'
        confirmLoading={loading}
        destroyOnClose
        width={600}
      >
        <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
          <Col xs={24} sm={12}>
            <Input readOnly defaultValue={name} addonBefore='Nombre' />
          </Col>
          <Col xs={24} sm={12}>
            <Input defaultValue={editLatitude ?? ''} placeholder='Latitude' addonBefore='Lat' onChange={e => setEditLatitude(e.target.value)} />
          </Col>
          <Col xs={24} sm={12}>
            <Input defaultValue={editLongitude ?? ''} placeholder='Longitude' addonBefore='Lng' onChange={e => setEditLongitude(e.target.value)} />
          </Col>
          <Col xs={24} sm={12}>
            <Input defaultValue={editPhaseOut ?? ''} placeholder='Phase Out' addonBefore='Phase Out' onChange={e => setEditPhaseOut(e.target.value)} />
          </Col>
          <Col xs={24} sm={12}>
            <Input defaultValue={editEntryYear ?? ''} placeholder='Entry Year' type='number' addonBefore='Entry Year' onChange={e => setEditEntryYear(e.target.value)} />
          </Col>
          <Col xs={24} sm={12}>
            <TimePicker
              defaultValue={editDistance ? moment(editDistance, 'H:mm:ss') : undefined}
              format='H:mm:ss'
              placeholder='Distance (H:mm:ss)'
              style={{ width: '100%' }}
              onChange={(_time, timeStr) => setEditDistance(timeStr)}
            />
          </Col>
          <Col xs={24} sm={12}>
            <Input defaultValue={editOptional ?? ''} placeholder='Optional' addonBefore='Optional' onChange={e => setEditOptional(e.target.value)} />
          </Col>
        </Row>
      </Modal>

      {(open) && (
        <>
          {(itemDataList.length > 0) ? (
            <Row style={{ marginLeft: '1rem' }}>
              <Col span={24}>
                {itemDataList.map((value, index) => (
                  <RegionItem data={value} key={index}/>
                ))}
              </Col>
            </Row>
          ) : (
            <Empty />
          )}
        </>
      )}
    </>
  );
}

export default RegionItem;
